// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 분배금 현황 화면 */

/* ── 툴바 ── */
.ds-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}

.ds-select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

.ds-year-select {
  width: 80px;
}

/* 라디오 그룹 */
.ds-radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fafafa;
}

.ds-radio-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ds-radio-label input[type="radio"] { cursor: pointer; }

/* 이자포함 체크박스 */
.ds-check-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 4px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fafafa;
}

.ds-check-label input[type="checkbox"] { cursor: pointer; }

/* 연도 합계 표시 */
.ds-year-summary {
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 4px;
  white-space: nowrap;
}

.ds-prev-summary {
  color: #666;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}

.ds-curr-summary {
  color: #1565c0;
  background: #e3f2fd;
  border: 1px solid #90caf9;
}

/* ── 리사이즈 핸들 ── */
.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.col-resize-handle:hover {
  background: rgba(0, 0, 0, 0.15);
}

/* ── 그리드 ── */
.ds-grid-wrapper {
  flex: 1 1;
  overflow: auto;
  min-height: 0;
}

/* 고정 컬럼 공통 (left는 inline style로 동적 설정) */
.ds-grid .ds-freeze-c1 { border-right: 1px solid #dde2ef; }
.ds-grid .ds-freeze-c2 { border-right: 1px solid #dde2ef; }
.ds-grid .ds-freeze-c3 { border-right: 2px solid #cdd3e8; }

/* 고정 컬럼 배경 (position:sticky로 left offset이 정상 동작) */
.ds-grid tbody td.col-freeze                            { background: white; position: sticky; z-index: 1; }
.ds-grid tbody tr.ds-row-deposit td.col-freeze          { background: #f0f8ff; }
.ds-grid thead th.col-freeze                            { background: #f0f2f8; position: sticky; z-index: 2; }
.ds-grid tbody tr.ds-total-row td.col-freeze            { background: #3a3f5c !important; z-index: 4; }

/* ── 합계 행 ── */
.ds-total-row {
  background-color: #3a3f5c !important;
  color: white !important;
  font-weight: 700;
  position: sticky;
  top: 0;
  z-index: 3;
}

.ds-total-row td.col-freeze {
  z-index: 5;
}

.ds-total-row td {
  background-color: #3a3f5c !important;
  color: white !important;
}

.ds-total-label { font-weight: 700; }
.ds-total-cell  { font-weight: 700; }

/* ── 이자/CMA 종목 행 ── */
.ds-row-deposit { background-color: #f0f8ff; }

/* ── 읽기전용 (투자잔액) ── */
.ds-readonly {
  color: #555;
  background-color: #fafafa;
}

/* ── 연합계 셀 ── */
.ds-annual {
  font-weight: 600;
  color: #1a1a2e;
  background-color: #f5f7ff;
}

/* hover */
.ds-grid tbody tr:hover td                         { background-color: #f5f7ff; }
.ds-grid tbody tr.ds-row-deposit:hover td          { background-color: #e6f3ff; }
.ds-grid tbody tr:hover td.col-freeze              { background-color: #f5f7ff; }
.ds-grid tbody tr.ds-row-deposit:hover td.col-freeze { background-color: #e6f3ff; }
.ds-grid tbody tr.ds-total-row:hover td            { background-color: #3a3f5c !important; }

/* ── 하단 그래프 ── */
.ds-chart-wrapper {
  flex-shrink: 0;
  padding: 12px 16px 8px;
  border-top: 1px solid #e8ecf4;
  background: white;
}

.ds-chart-title {
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
}

/* ── 커스텀 툴팁 ── */
.ds-chart-tooltip {
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  min-width: 160px;
}

.ds-tt-label {
  font-weight: 700;
  margin-bottom: 4px;
  color: #333;
}

.ds-tt-prev  { color: #78909c; margin: 2px 0; }
.ds-tt-curr  { color: #1565c0; margin: 2px 0; font-weight: 600; }

.ds-tt-diff-pos {
  color: #2e7d32;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #eee;
  font-weight: 600;
}

.ds-tt-diff-neg {
  color: #c62828;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid #eee;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/status/DividendSummaryPage.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,sCAAsC,eAAe,EAAE;;AAEvD,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yCAAyC,eAAe,EAAE;;AAE1D,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA,yCAAyC;AACzC,yBAAyB,+BAA+B,EAAE;AAC1D,yBAAyB,+BAA+B,EAAE;AAC1D,yBAAyB,+BAA+B,EAAE;;AAE1D,mDAAmD;AACnD,0DAA0D,iBAAiB,EAAE,gBAAgB,EAAE,UAAU,EAAE;AAC3G,0DAA0D,mBAAmB,EAAE;AAC/E,0DAA0D,mBAAmB,EAAE,gBAAgB,EAAE,UAAU,EAAE;AAC7G,0DAA0D,8BAA8B,EAAE,UAAU,EAAE;;AAEtG,eAAe;AACf;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,gBAAgB,EAAE;;AAEpC,sBAAsB;AACtB,kBAAkB,yBAAyB,EAAE;;AAE7C,sBAAsB;AACtB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,UAAU;AACV,qDAAqD,yBAAyB,EAAE;AAChF,qDAAqD,yBAAyB,EAAE;AAChF,qDAAqD,yBAAyB,EAAE;AAChF,uDAAuD,yBAAyB,EAAE;AAClF,qDAAqD,oCAAoC,EAAE;;AAE3F,iBAAiB;AACjB;EACE,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,eAAe,cAAc,EAAE,aAAa,EAAE;AAC9C,eAAe,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAEhE;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB","sourcesContent":["/* 분배금 현황 화면 */\n\n/* ── 툴바 ── */\n.ds-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.ds-select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n.ds-year-select {\n  width: 80px;\n}\n\n/* 라디오 그룹 */\n.ds-radio-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 4px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: #fafafa;\n}\n\n.ds-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ds-radio-label input[type=\"radio\"] { cursor: pointer; }\n\n/* 이자포함 체크박스 */\n.ds-check-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  user-select: none;\n  padding: 4px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: #fafafa;\n}\n\n.ds-check-label input[type=\"checkbox\"] { cursor: pointer; }\n\n/* 연도 합계 표시 */\n.ds-year-summary {\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.ds-prev-summary {\n  color: #666;\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n}\n\n.ds-curr-summary {\n  color: #1565c0;\n  background: #e3f2fd;\n  border: 1px solid #90caf9;\n}\n\n/* ── 리사이즈 핸들 ── */\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.col-resize-handle:hover {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n/* ── 그리드 ── */\n.ds-grid-wrapper {\n  flex: 1;\n  overflow: auto;\n  min-height: 0;\n}\n\n/* 고정 컬럼 공통 (left는 inline style로 동적 설정) */\n.ds-grid .ds-freeze-c1 { border-right: 1px solid #dde2ef; }\n.ds-grid .ds-freeze-c2 { border-right: 1px solid #dde2ef; }\n.ds-grid .ds-freeze-c3 { border-right: 2px solid #cdd3e8; }\n\n/* 고정 컬럼 배경 (position:sticky로 left offset이 정상 동작) */\n.ds-grid tbody td.col-freeze                            { background: white; position: sticky; z-index: 1; }\n.ds-grid tbody tr.ds-row-deposit td.col-freeze          { background: #f0f8ff; }\n.ds-grid thead th.col-freeze                            { background: #f0f2f8; position: sticky; z-index: 2; }\n.ds-grid tbody tr.ds-total-row td.col-freeze            { background: #3a3f5c !important; z-index: 4; }\n\n/* ── 합계 행 ── */\n.ds-total-row {\n  background-color: #3a3f5c !important;\n  color: white !important;\n  font-weight: 700;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n}\n\n.ds-total-row td.col-freeze {\n  z-index: 5;\n}\n\n.ds-total-row td {\n  background-color: #3a3f5c !important;\n  color: white !important;\n}\n\n.ds-total-label { font-weight: 700; }\n.ds-total-cell  { font-weight: 700; }\n\n/* ── 이자/CMA 종목 행 ── */\n.ds-row-deposit { background-color: #f0f8ff; }\n\n/* ── 읽기전용 (투자잔액) ── */\n.ds-readonly {\n  color: #555;\n  background-color: #fafafa;\n}\n\n/* ── 연합계 셀 ── */\n.ds-annual {\n  font-weight: 600;\n  color: #1a1a2e;\n  background-color: #f5f7ff;\n}\n\n/* hover */\n.ds-grid tbody tr:hover td                         { background-color: #f5f7ff; }\n.ds-grid tbody tr.ds-row-deposit:hover td          { background-color: #e6f3ff; }\n.ds-grid tbody tr:hover td.col-freeze              { background-color: #f5f7ff; }\n.ds-grid tbody tr.ds-row-deposit:hover td.col-freeze { background-color: #e6f3ff; }\n.ds-grid tbody tr.ds-total-row:hover td            { background-color: #3a3f5c !important; }\n\n/* ── 하단 그래프 ── */\n.ds-chart-wrapper {\n  flex-shrink: 0;\n  padding: 12px 16px 8px;\n  border-top: 1px solid #e8ecf4;\n  background: white;\n}\n\n.ds-chart-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 6px;\n}\n\n/* ── 커스텀 툴팁 ── */\n.ds-chart-tooltip {\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.12);\n  min-width: 160px;\n}\n\n.ds-tt-label {\n  font-weight: 700;\n  margin-bottom: 4px;\n  color: #333;\n}\n\n.ds-tt-prev  { color: #78909c; margin: 2px 0; }\n.ds-tt-curr  { color: #1565c0; margin: 2px 0; font-weight: 600; }\n\n.ds-tt-diff-pos {\n  color: #2e7d32;\n  margin-top: 4px;\n  padding-top: 4px;\n  border-top: 1px solid #eee;\n  font-weight: 600;\n}\n\n.ds-tt-diff-neg {\n  color: #c62828;\n  margin-top: 4px;\n  padding-top: 4px;\n  border-top: 1px solid #eee;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
